// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "loginauto" + "." + "c0ed70a6" + ".js";
};